module.exports = {
    API_BASE_URL: process.env.REACT_APP_BASE_URL,
    MEAL_TYPE: {
        FULL: 1,
        BREAKFAST: 2,
        LUNCH: 3,
        NONE: 4,
    },
    LEAVE_QUOTES: [
        "It is so hard to leave—until you leave. And then it is the easiest goddamned thing in the world.",
        "I was always holding onto people, and they were always leaving.",
        "Everybody has to leave, everybody has to leave their home and come back so they can love it again for all new reasons.",
        "Leave something for someone but dont leave someone for something.",
        "We all take different paths in life, but no matter where we go, we take a little of each other everyhwere.",
        "I'm guilty of giving people more chances than they deserve but when I'm done, I'm done.",
        "And I realized that there's a big difference between deciding to leave and knowing where to go.",
        "You get use to someone—start to like them, even—and they leave. In the end, everyone leaves.",
        "Do you know what your problem is? You can't live with the idea that someone might leave.",
        "It's not that I want you to go, it's just that I don't want you to stay.",
        "...and that, in the end, the most interesting people always leave.",
        "I don't want just words. If that's all you have for me, you'd better go"
    ],
    WEEK_DAYS: {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday"
    },
}
